// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/distribuidores',
  component: () => import('modules/distributors/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Distribuidores',
            name: 'ListDistributors'
          }
        ]
      },
      name: 'ListDistributors',
      component: () => import('modules/distributors/List.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.distribuidor.listar')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'criar',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Distribuidores',
            name: 'ListDistributors'
          }
        ]
      },
      name: 'Create',
      component: () => import('modules/distributors/Create.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.distribuidor.criar')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: ':editar',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Distribuidores',
            name: 'ListDistributors'
          }
        ]
      },
      name: 'Edit',
      component: () => import('modules/distributors/Edit.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.distribuidor.editar')) {
          next();
        } else {
          next('/');
        }
      }
    }
  ]
};
